import { RouteResult } from '@tripian/react';

interface IDemoData {
  // Demo City
  cityId: number;

  // FlightCard
  flightCard: {
    checkinDetail: { title: string; desc: string; airline: string };
    airportAccommendationLeg: RouteResult.ILeg;
  };
}

const demoData: IDemoData = {
  // Demo City
  cityId: 29,

  // FlightCard
  flightCard: {
    checkinDetail: { title: 'YYZ-YUL', desc: 'Terminal 2, Gate 26B, Seat 12A', airline: 'Lufthansa' },
    airportAccommendationLeg: {
      distance: { text: '3,8 km', value: 3.8 },
      duration: { text: '12 mins', value: 12 },
      travel: {
        text: '',
        value: google.maps.TravelMode.DRIVING,
        between: {
          pickup: {
            coordinate: { lat: 45.4660835, lng: -73.7458001 },
            nickname: 'Montréal–Pierre Elliott Trudeau Airport',
            formatted_address: 'Romeo-Vachon Blvd N, Dorval, Quebec H4Y 1H1, Canada',
          },
          // will update with accommendation data
          dropoff: {
            coordinate: { lat: 45.4660835, lng: -73.7458001 },
            nickname: 'accommendation.name',
            formatted_address: 'accommendation.address',
          },
        },
      },
    },
  },
};

export default demoData;
